import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { NavController, PopoverController, ModalController, AlertController, ToastController, LoadingController, App } from 'ionic-angular';
import { ViewContactPage } from '../view-contact/view-contact';
import { EditPopoverPage } from '../edit-popover/edit-popover';
import firebase from 'firebase/app';
import { ChangeAssignedBrokerPage } from '../change-assigned-broker/change-assigned-broker';
import { LoadingProvider } from '../../providers/loading/loading';
import { Http, RequestOptions, Headers } from '@angular/http';
import { StepformPage } from '../stepform/stepform';
import { TentativeRealEstateAssetPage } from '../tentative-real-estate-asset/tentative-real-estate-asset';
import { ChangeLogProfilePage } from '../change-log-profile/change-log-profile';
import { HomeService } from '../../app/services/home-service';
import { EnvDataService } from '../../app/services/env-data-service';
import { ContactFormService } from '../edit-contact-form-list/services/contact-form.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EditContactList } from '../edit-contact-form-list/edit-contact-from-list';
import { ShowContactForm } from '../show-contact/show-contact';
import {AdfListService} from '../adf-page/services/adf-list.service';
import {AdfPage} from '../adf-page/adf-page';
import {ViewAdfPage} from '../view-adf/view-adf';
import { ADFFormService } from '../adf-page/services/adf-form.service';

@Component({
  selector: 'adf-list-page',
  templateUrl: 'adf-list.html',
  providers: [EnvDataService, ContactFormService,ADFFormService]
})
export class AdfList implements OnInit {

  addContactForm: FormGroup;
  public adfList: any[];
  public userRole: any;
  public allBrokers: any;
  public loadedUsersList: any[];
  public contactTotal: number;
  public contactTmore: number;
  public limit = 20;
  public offset = 1;
  public addContactShow =false;
  public inputSearch ='';
  public uid = '';
  public broker_uid:any = [];
  constructor(
    public navCtrl: NavController,
    private firestore: AngularFirestore,
    public loadingProvider: LoadingProvider,
    public popoverCtrl: PopoverController,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public http: Http,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    public HomeService: HomeService,
    public db: AngularFirestore,
    private EnvDataService: EnvDataService,
    private ContactFormService: ContactFormService,
    public ADFFormservice:ADFFormService,
    public formBuilder: FormBuilder,
    public app: App,


    public afdService:AdfListService
  ) {
    this.addContactForm = formBuilder.group({
      firstname: ['', Validators.compose([Validators.required])],
      lastname: ['', Validators.compose([Validators.required])],
      mobile_phone: ['', Validators.compose([Validators.required, Validators.minLength(12), Validators.maxLength(12)])],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      reference_broker: [''],
    });

    this.userRole = window.localStorage.getItem("userRole");
    this.uid = window.localStorage.getItem("uid");
    if (this.userRole == 'super_admin') {
      let reference_broker = this.addContactForm.get('reference_broker');
      reference_broker.setValidators(Validators.required);
      reference_broker.updateValueAndValidity();
    }


    let thiss = this;

    this.getAdflist();
  }

  ngOnInit() {
    //debugger;
    this.contactTmore = 1;



  }

  getAdflist() {

    if(this.userRole == 'broker') {
      //let broker_uid = [];
      //this.limit = 10;
      this.broker_uid.push(this.uid);
      this.afdService.getAllAdfList(this.limit, this.offset,this.broker_uid).then((data) => {

        this.assigndata(data);

      });

    }
    else if(this.userRole == 'loan_admin') {

      this.ContactFormService.getUserdata(this.uid).then((brokerdata:any) => {
        this.broker_uid = brokerdata.assigned_broker;
       this.afdService.getAllAdfList(this.limit, this.offset,this.broker_uid).then((data) => {

         //console.log(data);
         this.assigndata(data);

       });


     });
    }
    else {
      this.afdService.getAllAdfList(this.limit, this.offset).then((data) => {

        this.assigndata(data);

      });
    }

  }

  searchAdf(event) {
    console.log(event);
    //debugger;
   let searchkey =  event.value;
   this.inputSearch = event.value;
    if(searchkey !== '') {
      //console.log(this.allcontactlist);
        //this.filterdata(searchkey)
        //console.log(this.allcontactlist);
        this.afdService.searchAllAdfs(searchkey).then((data:any = []) => {
          console.log(data);
          this.assigndata(data);
        });
    }
    else {
      this.getAdflist();
    }
  }

  searchUserFocus(){
    var limit = '';
    var offset= '';
    if(this.inputSearch == '') {
      this.afdService.getAllAdfList(limit, offset).then((data:any) => {

        if(data.length!=0){
          this.assigndata(data);
        }

      });
    }
    else {

      var input, filter, table, tr, td, td1, td2, td3, i, txtValue, txtValue1, txtValue2,txtValue3;
      // input = evt.srcElement.value;
      input = this.inputSearch
      filter = input.toLowerCase();
      table = document.getElementById("myTable");
      tr = table.getElementsByTagName("tr");
      for (i = 0; i < tr.length; i++) {
        td = tr[i].getElementsByTagName("td")[0];
        td1 = tr[i].getElementsByTagName("td")[1];
        td2 = tr[i].getElementsByTagName("td")[2];
        td3 = tr[i].getElementsByTagName("td")[3];
        if (td) {
          this.contactTmore = 0;
          txtValue = td.textContent || td.innerText;
          txtValue1 = td1.textContent || td1.innerText;
          txtValue2 = td2.textContent || td2.innerText;
          txtValue3 = td3.textContent || td3.innerText;
          if (txtValue.toLowerCase().indexOf(filter) > -1 || txtValue1.toLowerCase().indexOf(filter) > -1 || txtValue2.toLowerCase().indexOf(filter) > -1 || txtValue3.toLowerCase().indexOf(filter) > -1) {
            tr[i].style.display = "";
          } else {
            tr[i].style.display = "none";

          }
        }

        if(input==""||input==null||input==undefined){
          this.contactTmore = 1;
          this.getAdflist();
        }

      }

    }

  }


  assigndata(data) {

    data.forEach(adfelement => {

      if(adfelement.hasOwnProperty('accessGrantedFromUser')){
        // console.log('yes exits');
        }
        else {
          adfelement.accessGrantedFromUser = 0;
        }
    });

    this.adfList = data;
    this.loadedUsersList = data;

  }

  presentToast(err) {
    const toast = this.toastCtrl.create({
      message: err,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  edit(adf_id,user_id) {
    this.navCtrl.push(AdfPage,{
      user_id:user_id,
      form_id:adf_id,
      edit_flag:'edit'
    });
  }

  getFilterData(contactsArr){
    let user_id:any;
    contactsArr.forEach(data=>{
      if(data.type === 'primary'){
        user_id=data.user_data.uid
      }
    })
    return user_id;
  }

  goToNewAdfPage(){
    this.navCtrl.push(AdfPage);
  }

  getname(obj){
    let firstname:any;
    let lastname:any;
    let fullname:any;
    obj.contacts.forEach(data=>{
      if(data.type === 'primary')
      {
        firstname=data.user_data.firstname;
        lastname=data.user_data.lastname;
        fullname=firstname.concat(' ',lastname)
      }
    });
    return fullname;
  }

  delete(adf_id,user_id,thisobj) {

    let alert = this.alertCtrl.create({
      title: 'Confirm delete Applicant',
      message: 'Are you sure you want to delete this adf Applicant?',
      buttons: [
        {
          text: 'No',
          handler: () => {

          }
        },
        {
          text: 'Yes',
          handler: () => {

            this.loadingProvider.startLoading();
            this.ContactFormService.deleteSpecificApplication(user_id,adf_id)
            .then(data=>{
              if (data['message'] == "Document successfully deleted!") {
                this.getAdflist();
              } else {
                this.presentToast(data['message']);
              }
              this.loadingProvider.stopLoading();
            }).catch(error=>{

            })
          }
        }
      ]
    });
    alert.present();
  }

  newAdf(event,SDF_form_document_id,adf_title) {

    let alert = this.alertCtrl.create({
      title: 'Do you want to create a copy of '+adf_title+'?',
      buttons: [
        {
          text: 'No',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Yes',
          handler: () => {
            console.log('Yes clicked');
            this.ContactFormService.cloneApplicantDetailsbyId(SDF_form_document_id).then((data:any) => {

              this.getAdflist();

              this.navCtrl.push(AdfPage,{
                 user_id:data.user_id,
                 form_id:data.adf_form_id,
                 edit_flag:'edit'
               });

           })
          }
        }
      ]
    });
    alert.present();


  }

  searchUser(evt) {

    if (!evt.srcElement.value) {
      this.inputSearch = '';
      this.getAdflist();
      return;
    }
    var input, filter, table, tr, td, td1, td2, td3, i, txtValue, txtValue1, txtValue2,txtValue3;
    input = evt.srcElement.value;
    filter = input.toLowerCase();
    table = document.getElementById("myTable");
    tr = table.getElementsByTagName("tr");
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByTagName("td")[0];
      td1 = tr[i].getElementsByTagName("td")[1];
      td2 = tr[i].getElementsByTagName("td")[2];
      td3 = tr[i].getElementsByTagName("td")[3];
      if (td) {
        this.contactTmore = 0;
        txtValue = td.textContent || td.innerText;
        txtValue1 = td1.textContent || td1.innerText;
        txtValue2 = td2.textContent || td2.innerText;
        txtValue3 = td3.textContent || td3.innerText;
        if (txtValue.toLowerCase().indexOf(filter) > -1 || txtValue1.toLowerCase().indexOf(filter) > -1 || txtValue2.toLowerCase().indexOf(filter) > -1 || txtValue3.toLowerCase().indexOf(filter) > -1) {
          tr[i].style.display = "";
        } else {
          tr[i].style.display = "none";

        }
      }

      if(evt.srcElement.value==""||evt.srcElement.value==null||evt.srcElement.value==undefined){
        this.contactTmore = 1;
        this.inputSearch = '';
        this.getAdflist();
      }

    }

  }

  loadData(event, endBefore) {

    debugger;
    this.offset=this.offset+1;
    var limit = 20;

    //this.getAdflist();
    if(this.inputSearch == '')
    {
      if(this.userRole == 'broker') {
        let broker_uid = [];
        //this.limit = 10;
        broker_uid.push(this.uid);
        this.afdService.getAllAdfList(this.limit, this.offset,broker_uid).then((data) => {
          event.complete();
          this.assigndata(data);

        });

      }
      else if(this.userRole == 'loan_admin') {
        this.afdService.getAllAdfList(this.limit, this.offset,this.broker_uid).then((data) => {
          event.complete();
          //console.log(data);
          this.assigndata(data);

        });
      }
      else {
        this.afdService.getAllAdfList(this.limit, this.offset).then((data) => {
          event.complete();
          this.assigndata(data);

        });
      }
    }

    // this.afdService.getAllAdfList(this.limit, this.offset).then((data) => {

    //   event.complete();
    //   this.assigndata(data);

    // });

    // setTimeout(() => {
    //   event.complete();

    // }, 3000)

  }

  assigndataload(data) {
    this.adfList = this.adfList.concat(data);
  }


  initializeItems(): void {
    this.adfList = this.loadedUsersList;
  }

  viewContact(adf_id,user_id){
    debugger;
    this.navCtrl.push(ViewAdfPage,{
      contact_uid:user_id,
      SDF_form_document_id:adf_id,
    });
  }

  clickedStar() {
    debugger;
    console.log('working');
  }

}


// WEBPACK FOOTER //
// ./src/pages/adf-list/adf-list.ts